<template>
    <div class="password-requirements">
        <p>密碼須符合以下規則：</p>
        <ul aria-live="polite">
            <li
                v-for="requirement in requirements"
                :key="requirement.key"
                :class="{ 'is-met': requirement.isMet }"
            >
                <b-icon
                    :icon="requirement.isMet ? 'check-circle-fill' : 'circle'"
                    aria-hidden="true"
                ></b-icon>
                <span>{{ requirement.text }}</span>
                <span class="sr-only">{{ requirement.isMet ? '已符合' : '未符合' }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'PasswordRequirements',
    props: {
        password: {
            type: String,
            default: '',
        },
        account: {
            type: String,
            default: '',
        },
        includeAccountRule: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        requirements() {
            const password = this.password || '';
            const requirements = [
                { key: 'length', text: '至少 12 碼', isMet: password.length >= 12 },
                { key: 'uppercase', text: '包含大寫英文字母', isMet: /[A-Z]/.test(password) },
                { key: 'lowercase', text: '包含小寫英文字母', isMet: /[a-z]/.test(password) },
                { key: 'number', text: '包含數字', isMet: /[0-9]/.test(password) },
                { key: 'special', text: '包含特殊字元', isMet: /[^A-Za-z0-9]/.test(password) },
            ];

            if (this.includeAccountRule) {
                const account = this.account || '';
                requirements.push({
                    key: 'account',
                    text: '不可包含帳號',
                    isMet:
                        Boolean(password) &&
                        Boolean(account) &&
                        !password.toLowerCase().includes(account.toLowerCase()),
                });
            }

            return requirements;
        },
    },
};
</script>

<style lang="scss" scoped>
.password-requirements {
    margin-top: 0.65rem;
    color: #6c757d;
    font-size: 0.875rem;
}

.password-requirements p {
    margin-bottom: 0.4rem;
}

.password-requirements ul {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.4rem 0.75rem;
    padding: 0;
    margin: 0;
    list-style: none;
}

.password-requirements li {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.password-requirements li.is-met {
    color: #198754;
}

@media (max-width: 575.98px) {
    .password-requirements ul {
        grid-template-columns: 1fr;
    }
}
</style>
